import refs from '../helpers/refs'

class CSliderBlog {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-slider-blog')
    .forEach(el => new CSliderBlog(el))
})
